import AllProductsView from "views/AllProductsView/AllProductsView";

export default AllProductsView;